export default __webpack_public_path__ + "static/media/ftm.5c12026b.5c12026b.svg";